import Tesseract from 'tesseract.js';

/**
 * Runs OCR on a given file and returns the extracted text.
 * @param {File} file - The image file to process.
 * @param {number} rotation - specified picture rotation in degrees to be done before OCR operation
 * @param {string} lang - Language code for OCR (default: 'pol').
 * @returns {Promise<string>} - Extracted text from the image.
 */
export async function runOCR(file, rotation = 0, lang = 'pol') {
    let image = file
    // if ( rotation !== 0 ){
    //     image = await rotateImage(file, rotation);
    // }

    try {
        const { data } = await Tesseract.recognize(image, lang, {
            logger: m => console.log(m),
        });
        return data.text;
    } catch (err) {
        console.error('OCR failed:', err);
        return '';
    }
}

/**
 * Loads an image from a File object.
 * @param {File} file
 * @returns {Promise<HTMLImageElement>}
 */
function loadImageFromFile(file) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = URL.createObjectURL(file);
    });
}

/**
 * Converts an image to grayscale using canvas.
 * @param {HTMLImageElement} image
 * @returns {HTMLCanvasElement}
 */
function preprocessImage(image) {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = image.width;
    canvas.height = image.height;

    ctx.drawImage(image, 0, 0);
    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const data = imageData.data;

    for (let i = 0; i < data.length; i += 4) {
        const avg = (data[i] + data[i + 1] + data[i + 2]) / 3;
        data[i] = data[i + 1] = data[i + 2] = avg;
    }

    ctx.putImageData(imageData, 0, 0);
    return canvas;
}

function rotateImage(image, angle) {
    return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");

            if (angle === 90 || angle === 270) {
                canvas.width = img.height;
                canvas.height = img.width;
            } else {
                canvas.width = img.width;
                canvas.height = img.height;
            }

            ctx.translate(canvas.width / 2, canvas.height / 2);
            ctx.rotate((angle * Math.PI) / 180);
            ctx.drawImage(img, -img.width / 2, -img.height / 2);

            resolve(canvas.toDataURL("image/png"));
        };
        img.src = typeof image === "string" ? image : URL.createObjectURL(image);
    });
}

